<template>
  <!-- 原生video标签 -->
  <div>
    <!-- <div  v-for="item in videos" :key="item.id">
      <video :src="item.src"  controls autoplay name='media' class="video" style="width: auto; height:400px; object-fit: contain">
    </video>
    </div> -->
    <!-- {{videos}} -->

    <el-col :span="11" v-for="(item) in videos" :key="item.id" style="margin:10px;">
    <el-card :body-style="{ padding: '0px' }">
      <video :src="item.src"  controls autoplay name='media' class="video" style="height:auto;width: 100%; object-fit: contain">
    </video>
      <div style="padding: 14px;">
        <span>{{item.filename}}</span>
        <div class="bottom clearfix">
         <p style="font-size: 13px;color: #999;">上传时间：{{item.add_time}}</p>
          <!-- <el-button type="text" class="button">操作按钮</el-button> -->
        </div>
      </div>
    </el-card>
  </el-col>

  </div>
</template>
<script>

export default {
  props: {
    srcList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    srcList(val) {
      // const videos = val.filter(item => item.path.indexOf('.mp4') > -1)
      // videos.forEach(v => {
      //   v.src = process.env.VUE_APP_BASE_API + '/common/video/' + v.id
      // })
      // this.videos = videos
      this.videos = []
      val.forEach(v => {
        if (v.path.indexOf('.mp4') > -1 || v.path.indexOf('.mpeg') > -1 || v.path.indexOf('.avi') > -1 || v.path.indexOf('.mov') > -1 ||
        v.path.indexOf('.wmv') > -1 || v.path.indexOf('.3gp') > -1 || v.path.indexOf('.flv') > -1 || v.path.indexOf('.rmvb') > -1) {
          v.src = process.env.VUE_APP_BASE_API + '/common/video/' + v.id
          this.videos.push(v)
        }
      })
    }
  },
  data() {
    return {
      videos: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.video:focus {
  outline: 0 none
}
</style>

